package site.shadadman.pages.worklog.marketmlm

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initJune152017MarketMLMFirstSprintPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/marketmlm/june152017MarketMLMFirstSprint.md", FrontMatterElement.Builder { addScalar("title", "15june2017MarketmlmFirstSprint"); }))
}

@Page("/worklog/marketmlm/june152017-market-mlm-first-sprint")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun June152017MarketMLMFirstSprintPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("june-15-2017-MarketMLM_First_Sprint")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This weak at MarketMLM:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("We figure out the overall Android project architecture: To make this decision we created a flowchart of user stories. now because the website was already implemented figuring out the overall user story was really fast. We already had the auth layouts for mobile. Because the panel was a multi-tole pane including diff profiles for Customer, Vendors and Marketers, maked the profile a little complicated. The customer profile was the base one, other roles will inhereted from customer. Based on the above info, we decided to go with the following project infostructure:")
            }
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.P {
                        org.jetbrains.compose.web.dom.Text("MarketMLM")
                    }
                    org.jetbrains.compose.web.dom.Ul {
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.P {
                                org.jetbrains.compose.web.dom.Text("app")
                            }
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.P {
                                org.jetbrains.compose.web.dom.Text("features")
                            }
                            org.jetbrains.compose.web.dom.Ul {
                                org.jetbrains.compose.web.dom.Li {
                                    org.jetbrains.compose.web.dom.Text("profile")
                                }
                                org.jetbrains.compose.web.dom.Li {
                                    org.jetbrains.compose.web.dom.Text("main")
                                }
                                org.jetbrains.compose.web.dom.Li {
                                    org.jetbrains.compose.web.dom.Text("auth")
                                }
                                org.jetbrains.compose.web.dom.Li {
                                    org.jetbrains.compose.web.dom.Text("cart")
                                }
                                org.jetbrains.compose.web.dom.Li {
                                    org.jetbrains.compose.web.dom.Text("product")
                                }
                                org.jetbrains.compose.web.dom.Li {
                                    org.jetbrains.compose.web.dom.Text("post")
                                }
                                org.jetbrains.compose.web.dom.Li {
                                    org.jetbrains.compose.web.dom.Text("splash")
                                }
                                org.jetbrains.compose.web.dom.Li {
                                    org.jetbrains.compose.web.dom.Text("ticket")
                                }
                            }
                        }
                    }
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("each feature module included:")
            }
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("data")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("domain")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("scene")
                }
            }
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("obviously the clean arch is always the first and best choice. For the data architecture I decided to go with MVI for two reason, first it was new and interesting and i want it to learn it, second it was really a good match for compose, makes the ui code cleaner & more readable.")
            }
        }
    }
}
